import { observable } from 'mobx';

export type ForbiddenRequestFormArgs = {
  category: string;
};

export default class ForbiddenRequestForm {
  @observable category: string;

  constructor(args: ForbiddenRequestFormArgs) {
    this.category = args.category;
  }
}
